import { Css } from "~generated/css";
import { isDefined } from "~utils";
import { SummaryPrintConfiguration_CheckoutConfigFragment } from "../SummaryPrint.page.generated";
import { PDFPage } from "./PDFPage";
import { PrintHeader } from "./PrintHeader";

export function InteriorReport({ data }: { data: SummaryPrintConfiguration_CheckoutConfigFragment }) {
  const { name, customerEmail, createdAt, reservedAt, expiresAt, status, insideMapsRoomRenderings, interiorSubSteps } =
    data;

  // [SC-79311] Temporary fix to filter out stale images from the report where we are seeing renderings
  // getting saved when the user switches plans, but we don't clean up the old plan renderings.
  const insideMapsRoomLocationIds = new Set(interiorSubSteps.map((step) => step.location?.id).filter(isDefined));
  const filteredInsideMapsRoomRenderings = insideMapsRoomRenderings.filter((room) =>
    insideMapsRoomLocationIds.has(room.readyPlanLocation.id),
  );

  // Create a map of room location ID to display name for InsideMaps
  const roomDisplayNames = new Map(data.interiorSubSteps?.map((step) => [step.location?.id, step.displayName]) ?? []);

  // Normalize both data sources into a common shape
  const rooms = filteredInsideMapsRoomRenderings.map((room) => ({
    key: room.id,
    displayName: roomDisplayNames.get(room.readyPlanLocation.id) ?? room.readyPlanLocation.marketingName,
    imageUrl: room.asset?.largePreview,
    altText: room.readyPlanLocation.marketingName,
  }));

  return (
    <>
      {rooms.map((room) => (
        <PDFPage key={room.key}>
          <div css={Css.relative.h100.w100.bgWhite.$}>
            <div css={Css.df.ma.fdc.gap2.p1.pb4.asc.maxContainer.$}>
              <PrintHeader
                status={status}
                expiredAt={expiresAt}
                createdAt={createdAt}
                reservedAt={reservedAt}
                configurationName={name}
                customerEmail={customerEmail}
                checkoutConfigId={data.id}
                communityId={data.community.id}
              />
              <div css={Css.t16.gray900.fw600.$}>{room.displayName}</div>
              {room.imageUrl && <img src={room.imageUrl} css={Css.w100.ha.$} alt={room.altText} />}
            </div>
            {/* Disclaimer */}
            <div id="disclaimer" css={Css.t12.pt2.tac.gray700.$}>
              All images, design layouts, and renderings are intended for illustrative purposes only and may be subject
              to change. Layout and details will vary depending on selected floor plan.
            </div>
          </div>
        </PDFPage>
      ))}
    </>
  );
}
